var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOffersLogin = function SvgOffersLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3447 3.23507C15.7207 2.90886 16.2793 2.90886 16.6553 3.23507L18.5313 4.86262C18.7633 5.06391 19.0749 5.14741 19.3765 5.08909L21.8148 4.61756C22.3036 4.52305 22.7874 4.80238 22.9499 5.27289L23.7607 7.62036C23.861 7.91068 24.0891 8.13881 24.3795 8.23909L26.7269 9.04992C27.1974 9.21243 27.4768 9.69626 27.3823 10.185L26.9107 12.6234C26.8524 12.9249 26.9359 13.2366 27.1372 13.4686L28.7648 15.3445C29.091 15.7205 29.091 16.2792 28.7648 16.6552L27.1372 18.5311C26.9359 18.7631 26.8524 19.0747 26.9107 19.3763L27.3823 21.8147C27.4768 22.3034 27.1974 22.7872 26.7269 22.9498L24.3795 23.7606C24.0891 23.8609 23.861 24.089 23.7607 24.3793L22.9499 26.7268C22.7874 27.1973 22.3036 27.4766 21.8148 27.3821L19.3765 26.9106C19.0749 26.8523 18.7633 26.9358 18.5313 27.1371L16.6553 28.7646C16.2793 29.0908 15.7207 29.0908 15.3447 28.7646L13.4687 27.1371C13.2367 26.9358 12.9251 26.8523 12.6235 26.9106L10.1851 27.3821C9.69641 27.4766 9.21259 27.1973 9.05007 26.7268L8.23924 24.3793C8.13896 24.089 7.91083 23.8609 7.62051 23.7606L5.27304 22.9498C4.80254 22.7872 4.5232 22.3034 4.61771 21.8147L5.08924 19.3763C5.14756 19.0747 5.06406 18.7631 4.86278 18.5311L3.23522 16.6552C2.90901 16.2792 2.90901 15.7205 3.23522 15.3445L4.86278 13.4686C5.06406 13.2366 5.14756 12.9249 5.08924 12.6234L4.61771 10.185C4.5232 9.69626 4.80254 9.21243 5.27304 9.04992L7.62051 8.23909C7.91083 8.13881 8.13896 7.91068 8.23924 7.62036L9.05007 5.27289C9.21259 4.80238 9.69641 4.52305 10.1851 4.61756L12.6235 5.08909C12.9251 5.14741 13.2367 5.06391 13.4687 4.86262L15.3447 3.23507Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 10.6665L10.6667 21.3332",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0635 12.2163H12.101",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0635 20.2163H20.101",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOffersLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/OffersLogin.7a01587a.svg";
export { ForwardRef as ReactComponent };